import useFetchedDataWithPagination from 'hooks/useFetchedDataWithPagination'
import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { forwardRef, Fragment, RefObject, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import { toShortDate, toTime } from 'utils/date'
import { useReduxSelector } from 'store'
import Filters from 'components/Filters'
import Loading from 'components/Loading'
import Error from 'components/Error'
import * as fields from './fields'
import * as urls from 'rest/urls'

interface MagHistoryProps {
  id: string
  full?: boolean
  more?: basic.BasicFunc
}

const MagHistory = forwardRef<HTMLDivElement, MagHistoryProps>(({ id, full, more }, ref) => {
  const [filters, setFilters] = useState<basic.Form>({ warehousesIds: [id] })
  const { events } = useReduxSelector(state => selectWarehouse(state, id))

  const url = full ? getListUrl(filters) : ''
  const { isLoading, data, handleScroll } = useFetchedDataWithPagination<warehouse.WarehouseEvent>(url, ref as RefObject<HTMLDivElement>)
  const list = full ? data : events?.filter((_, i) => i < 3)

  const { t, lang } = useTranslation('account')

  return (
    <div className='menu__section'>
      {full && <Filters
        showFiltersBtn
        fields={fields[lang]}
        filters={filters}
        setFilters={setFilters}
      />}

      <div
        ref={ref}
        className='menu__history'
        onScroll={handleScroll}>

        {list?.map(({ id, title, description, datetime, icon }, i, arr) => {
          const showDate = i === 0 || arr[i - 1].datetime.substring(0, 10) !== datetime.substring(0, 10)
          const date = new Date(datetime)

          return <Fragment key={id}>
            {showDate && <>
              <div className='history__date'>{toShortDate(date, lang)}</div>
              <hr />
            </>}

            <div className='history__item'>
              <div className='group'>
                <div className='item__left'>
                  <div className='history__symbol center'>
                    <i className={`icon icon--${icon}`} />
                  </div>
                  <div className='history__desc'>
                    <div className='--secFont'>{title}</div>
                    <div>{description}</div>
                  </div>
                </div>
                <div className='history__time'>{toTime(date, lang)}</div>
              </div>
            </div>
          </Fragment>
        })}

        {isLoading && <Loading />}

        {(!events || events.length === 0) && <Error
          staticPos={!full}
          text={t('noItem')}
        />}

        {!full && <>
          <div
            className='menu__more center --secFont --high'
            onClick={more}>{t('more')} →</div>
          <hr />
        </>}
      </div>
    </div>
  )
})


const getListUrl = (filters: basic.Form) => {
  const params = generateFilterParams(filters)
  return `${urls.events}${params ? `?${params}` : ''}`
}

const generateFilterParams = (filters: basic.Form) => {
  let filtersParam = ''
  for (const key in filters) {
    if (key !== 'warehousesIds' && key !== 'search') {
      if (filtersParam) filtersParam += ';'
      if (key === 'datetime' || key === 'date') {
        filtersParam += `datetime::${filters[key]?.start || ''},${filters[key]?.end || ''}`
      } else {
        filtersParam += `${key}::${filters[key]}`
      }
    }
  }

  const params = new URLSearchParams()
  if (filtersParam) params.append('filters', filtersParam)
  if (filters.search) params.append('search', filters.search)
  if (filters['warehousesIds'] && Array.isArray(filters['warehousesIds']) && filters['warehousesIds'].length > 0) {
    params.append('warehousesIds', filters['warehousesIds'].reduce((r, id) => r += (r ? ',' : '') + id, ''))
  }
  return params.toString()
}

export default MagHistory